<template>
  <v-alert
    v-if="isRentOut && hasNoPayment"
    :class="breakPointChange"
    class="ml-auto mt-2 body-2"
    color="warning"
    text
  >
    <div class="d-flex align-center">
      <v-icon color="warning" left>
        mdi-alert-circle-outline
      </v-icon>
      <p class="body-2 mb-0">
        {{$t('rentOut.waitingPayment')}}
      </p>
    </div>
  </v-alert>
</template>

<script>
export default {
  name: 'QuoteWaitingPaymentMessage',

  props: {
    isRentOut: {
      type: Boolean,
      default: false,
    },

    hasNoPayment: {
      type: Boolean,
      default: false,
    },

    breakPointChange: {
      type: String | Boolean,
    }
  }
}
</script>
